var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.deleteItem == true)?[_c('p',[_vm._v("Êtes-vous sûr de vouloir supprimer ce projet ?")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v(_vm._s(_vm.$store.state.single.data.label))])])]:[_c('p',[_vm._v("Ce projets est lié à un ou plusieurs produits, merci de le(s) supprimer afin de procéder à la suppression de ce projet")])]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f182048","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/projects/single/Delete.vue
// module id = null
// module chunks = 